import { createHotamClient } from '@hotam/repository';

import { appEnv } from './env';

export const hotamClient = createHotamClient({ baseUrl: appEnv.apiBaseUrl });
